"use strict";

exports.__esModule = true;
exports.getRealTimeValuesFromBatchPacket = void 0;
var getRealTimeValuesFromBatchPacket = exports.getRealTimeValuesFromBatchPacket = function getRealTimeValuesFromBatchPacket(packet, dataItemsCount, realTimeChartItemDict) {
  var values = new Array(dataItemsCount).fill(0);
  if (packet !== undefined && realTimeChartItemDict !== undefined && Object.keys(realTimeChartItemDict).length > 0) {
    Object.keys(packet).forEach(function (key) {
      var index = realTimeChartItemDict[key];
      if (packet[key] !== undefined) {
        values[index] = packet[key].value;
      }
    });
  }
  return values;
};